/** Filled pushpin (Telegram-style), drawn upright then tilted in CSS. */
export function EngagePinIcon() {
	return (
		<svg className="engage-pin-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M12 22.667c-.552 0-1-.448-1-1v-5.333c0-.552.448-1 1-1s1 .448 1 1v5.333c0 .552-.448 1-1 1Z" />
			<path d="M18.572 12c-.355-.608-.771-1.184-1.239-1.717V5c0-2.023-1.644-3.667-3.667-3.667h-3.333c-2.023 0-3.667 1.644-3.667 3.667v5.279c-.469.533-.884 1.109-1.239 1.717-.751 1.287-1.228 2.703-1.42 4.211-.036.285.052.572.241.787.191.216.464.339.751.339H19c.287 0 .56-.124.751-.339.189-.216.277-.501.241-.787-.192-1.508-.669-2.924-1.42-4.211Z" />
		</svg>
	);
}
